import { useEffect, useRef, useState } from 'react'
import { useLvgState } from 'hooks/games/lvg/useLvgState'
import { useUser } from 'hooks/user/useUser'
import { LVG_GRAPH_OPTIONS } from 'constants/games/lvg/lvgGraphsOptions'
import { PriceGraph } from 'components/Organisms/PriceGraph'

export const LvgGraph = () => {
  const { defaultLvgGraphId, lastSelectedAssets } = useUser('preferences')
  const { activeAsset, activeGraphId, setActiveGraphId } = useLvgState()
  const [selectedOption, setSelectedOption] = useState(
    LVG_GRAPH_OPTIONS[lastSelectedAssets ? activeGraphId || defaultLvgGraphId : defaultLvgGraphId]
  )

  const firstRender = useRef(true)
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      return
    }
    setSelectedOption(LVG_GRAPH_OPTIONS[defaultLvgGraphId])
  }, [defaultLvgGraphId])

  const onSelectOption = (option) => {
    setActiveGraphId(option.id)
    setSelectedOption(option)
  }

  return (
    <div
      style={{
        width: '100%',
        height: 'calc(100% - 80px)',
      }}
    >
      <PriceGraph assetInfo={activeAsset} graphId={selectedOption?.id} onGraphId={onSelectOption} />
    </div>
  )
}
